/* eslint-disable max-len */
import React from 'react';

const ToolbarIcons: React.FC<{
  tool: string;
  strokeColor?: string;
  disabled?: boolean;
}> = ({tool, strokeColor = '#000', disabled = false}) => {
  let icon: React.ReactElement | null = null;
  switch (tool) {
    case 'save':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M11.667 5.83325H13.3334"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6666 17.5H4.16661C4.05716 17.5001 3.94877 17.4785 3.84763 17.4367C3.7465 17.3948 3.6546 17.3335 3.57719 17.2561C3.49978 17.1787 3.43837 17.0869 3.39647 16.9857C3.35457 16.8846 3.33301 16.7763 3.33301 16.6668V5.8332L6.66661 2.5H15.833C16.054 2.5 16.266 2.58777 16.4223 2.74401C16.5786 2.90026 16.6665 3.11218 16.6666 3.3332V17.5Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.3334 12.5H6.66699V17.5H13.3334V12.5Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'bold':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M5.375 9V3H9.22685C10.8583 3 12.1806 4.3431 12.1806 6C12.1806 7.6569 10.8583 9 9.22685 9H5.375ZM5.375 9H10.4212C12.0526 9 13.375 10.3431 13.375 12C13.375 13.6569 12.0526 15 10.4212 15H5.375V9Z"
            stroke="#101223"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'italic':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M7.375 2.01864H13.375M4.375 16H10.375M10.75 2L7 16"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'underline':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3 16.5H15"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.875 2.28638V8.25C13.875 10.9425 11.6925 13.125 9 13.125C6.3075 13.125 4.125 10.9425 4.125 8.25V2.28638"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'strikeThrough':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M1.875 9H16.125M9 9C15 11.25 12.75 16.5 9 16.5C5.25 16.5 4.5 13.5 4.5 13.5M13.5 4.5C13.5 4.5 12.375 1.5 9 1.5C5.625 1.5 4.2885 4.35 5.85375 6.75"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 13.5C4.5 13.5 6 16.5 9 16.5C12 16.5 13.7115 13.65 12.1462 11.25"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'textColor':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path d="M2 15H16V17H2V15Z" fill={strokeColor} />
          <path
            d="M6.79039 10H11.2104L12.2504 13H14.3704L10.4504 1.67C10.3104 1.27 9.93039 1 9.51039 1H8.51039C8.08039 1 7.70039 1.27 7.57039 1.67L3.65039 13H5.77039L6.81039 10H6.79039ZM9.00039 3.61L10.5204 8H7.48039L9.00039 3.61Z"
            fill="#101223"
          />
        </svg>
      );
      break;
    case 'highlight':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M13.7046 1.47497C13.3884 1.17075 12.9606 1 12.5148 1C12.0689 1 11.6411 1.17075 11.3249 1.47497L4.60759 7.87772C4.48945 7.98388 4.4135 8.12272 4.37975 8.27789L3.51899 11.9039L2 13.7415H4.38819L5.35021 12.8186L8.37975 12.1408C8.53165 12.1081 8.67511 12.0346 8.78481 11.9284L15.4937 5.53385C15.8143 5.22352 15.9916 4.81518 16 4.37417C16 3.93317 15.8228 3.52483 15.5021 3.21449L13.7131 1.48313L13.7046 1.47497ZM14.3038 4.35784L8.19409 10.1807L6.40506 8.44939L12.5148 2.62648L14.3038 4.35784Z"
            fill="#101223"
          />
          <path d="M2 15H16V17H2V15Z" fill={strokeColor} />
        </svg>
      );
      break;
    case 'table':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M24.5 22.167L24.5 5.83403C24.5 5.19003 23.9775 4.66699 23.3335 4.66699L4.66648 4.66699C4.02248 4.66699 3.5 5.18947 3.5 5.83403L3.5 22.167C3.5 22.811 4.02248 23.334 4.66648 23.334L23.3335 23.334C23.9775 23.334 24.5 22.8116 24.5 22.167Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.5 5.83403L24.5 9.33403L3.5 9.33403L3.5 5.83403C3.49993 5.6808 3.53004 5.52905 3.58863 5.38747C3.64722 5.24588 3.73313 5.11722 3.84145 5.00884C3.94978 4.90047 4.0784 4.81449 4.21996 4.75584C4.36152 4.69718 4.51325 4.66699 4.66648 4.66699L23.3335 4.66699C23.4868 4.66699 23.6385 4.69718 23.78 4.75584C23.9216 4.81449 24.0502 4.90047 24.1585 5.00884C24.2669 5.11722 24.3528 5.24588 24.4114 5.38747C24.47 5.52906 24.5001 5.6808 24.5 5.83403Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 20.5V13.5"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 20.5V13.5"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.833 17H7.5"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'pictures':
    case 'image':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M9.67176 23.3331H4.66648C4.35706 23.3329 4.06036 23.2099 3.84162 22.991C3.62288 22.7722 3.5 22.4754 3.5 22.166V18.3513L10.1618 11.666L15.7382 17.266L9.67176 23.3331ZM9.67176 23.3331L19.0053 13.9995L24.4994 19.4948V22.166C24.4995 22.3192 24.4694 22.471 24.4108 22.6126C24.3522 22.7542 24.2663 22.8828 24.158 22.9912C24.0497 23.0996 23.921 23.1856 23.7795 23.2442C23.6379 23.3029 23.4862 23.3331 23.333 23.3331H9.67176Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="18"
            cy="9.5"
            r="1.5"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.3335 4.66602H4.66648C4.02248 4.66602 3.5 5.1885 3.5 5.83306V22.166C3.5 22.81 4.02248 23.3331 4.66648 23.3331H23.3335C23.9775 23.3331 24.5 22.8106 24.5 22.166V5.83306C24.5 5.52363 24.3771 5.22688 24.1584 5.00803C23.9396 4.78919 23.6429 4.66616 23.3335 4.66602Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'screenshot':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M18.0406 20.4594L24.125 13M15.875 13L21.9594 20.4594M14.5 21.9375C14.5 22.2084 14.5533 22.4766 14.657 22.7268C14.7606 22.977 14.9126 23.2044 15.1041 23.3959C15.2956 23.5874 15.523 23.7394 15.7732 23.843C16.0234 23.9467 16.2916 24 16.5625 24C16.8334 24 17.1016 23.9467 17.3518 23.843C17.602 23.7394 17.8294 23.5874 18.0209 23.3959C18.2124 23.2044 18.3644 22.977 18.468 22.7268C18.5717 22.4766 18.625 22.2084 18.625 21.9375C18.625 21.6666 18.5717 21.3984 18.468 21.1482C18.3644 20.898 18.2124 20.6706 18.0209 20.4791C17.8294 20.2876 17.602 20.1356 17.3518 20.032C17.1016 19.9283 16.8334 19.875 16.5625 19.875C16.2916 19.875 16.0234 19.9283 15.7732 20.032C15.523 20.1356 15.2956 20.2876 15.1041 20.4791C14.9126 20.6706 14.7606 20.898 14.657 21.1482C14.5533 21.3984 14.5 21.6666 14.5 21.9375ZM21.375 21.9375C21.375 22.4845 21.5923 23.0091 21.9791 23.3959C22.3659 23.7827 22.8905 24 23.4375 24C23.9845 24 24.5091 23.7827 24.8959 23.3959C25.2827 23.0091 25.5 22.4845 25.5 21.9375C25.5 21.3905 25.2827 20.8659 24.8959 20.4791C24.5091 20.0923 23.9845 19.875 23.4375 19.875C22.8905 19.875 22.3659 20.0923 21.9791 20.4791C21.5923 20.8659 21.375 21.3905 21.375 21.9375Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.66602 23.333H13.3331M24.4995 11.166V5.83301"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2 2"
          />
          <path
            d="M4.66648 23.3331C4.02248 23.3331 3.5 22.81 3.5 22.166V5.83306C3.5 5.1885 4.02248 4.66602 4.66648 4.66602H23.3335C23.6429 4.66616 23.9396 4.78919 24.1584 5.00803C24.3771 5.22688 24.5 5.52363 24.5 5.83306"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'pageBreak':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M3.20801 13.9997H24.7913M4.66634 3.20801V6.41634C4.66634 7.03518 4.91217 7.62867 5.34976 8.06626C5.78734 8.50384 6.38084 8.74967 6.99967 8.74967H20.9997C21.6185 8.74967 22.212 8.50384 22.6496 8.06626C23.0872 7.62867 23.333 7.03518 23.333 6.41634V3.20801M4.66634 24.7913V21.583C4.66634 20.9642 4.91217 20.3707 5.34976 19.9331C5.78734 19.4955 6.38084 19.2497 6.99967 19.2497H20.9997C21.6185 19.2497 22.212 19.4955 22.6496 19.9331C23.0872 20.3707 23.333 20.9642 23.333 21.583V24.7913"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'comment':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M16.1667 21.0003H8.94483C8.43997 21.0003 7.94872 21.1641 7.54483 21.467L3.5 24.5003V7.00033C3.5 6.38149 3.74583 5.78799 4.18342 5.35041C4.621 4.91282 5.21449 4.66699 5.83333 4.66699H22.1667C22.7855 4.66699 23.379 4.91282 23.8166 5.35041C24.2542 5.78799 24.5 6.38149 24.5 7.00033V14.667"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5 17V24M19 20.5H26"
            stroke="#101223"
            strokeWidth="1.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'link':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M16.9165 11.084C17.6886 11.8582 18.1223 12.907 18.1223 14.0005C18.1223 15.0939 17.6886 16.1427 16.9165 16.9169L11.0835 22.7505C10.3093 23.5228 9.26035 23.9565 8.16677 23.9565C7.07318 23.9565 6.02424 23.5228 5.25001 22.7505C4.47768 21.9762 4.04395 20.9273 4.04395 19.8337C4.04395 18.7401 4.47768 17.6912 5.25001 16.9169"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.7502 11.0835C23.5225 10.3093 23.9563 9.26035 23.9563 8.16677C23.9563 7.07318 23.5225 6.02424 22.7502 5.25001C21.976 4.47768 20.927 4.04395 19.8334 4.04395C18.7398 4.04395 17.6909 4.47768 16.9167 5.25001L11.0837 11.0835C10.3116 11.8577 9.87793 12.9066 9.87793 14C9.87793 15.0935 10.3116 16.1423 11.0837 16.9165"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'shapes':
    case 'shape':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M12.0747 26.0782C10.6648 25.9778 9.60484 24.9173 9.50451 23.508C9.41351 22.2334 9.33301 20.3749 9.33301 17.7913C9.33301 15.2078 9.41351 13.3493 9.50451 12.0747C9.60484 10.6648 10.6653 9.60484 12.0747 9.50451C13.3493 9.41351 15.2078 9.33301 17.7913 9.33301C20.3749 9.33301 22.2334 9.41351 23.508 9.50451C24.9179 9.60484 25.9778 10.6653 26.0782 12.0747C26.1692 13.3493 26.2497 15.2078 26.2497 17.7913C26.2497 20.3749 26.1692 22.2334 26.0782 23.508C25.9778 24.9179 24.9173 25.9778 23.508 26.0782C22.2334 26.1692 20.3749 26.2497 17.7913 26.2497C15.2078 26.2497 13.3493 26.1692 12.0747 26.0782Z"
            fill="white"
          />
          <path
            d="M19.6262 6.41667C17.9422 3.62017 14.8767 1.75 11.375 1.75C6.05908 1.75 1.75 6.05908 1.75 11.375C1.75 14.8773 3.62017 17.9422 6.41667 19.6262"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.0747 26.0782C10.6648 25.9778 9.60484 24.9173 9.50451 23.508C9.41351 22.2334 9.33301 20.3749 9.33301 17.7913C9.33301 15.2078 9.41351 13.3493 9.50451 12.0747C9.60484 10.6648 10.6653 9.60484 12.0747 9.50451C13.3493 9.41351 15.2078 9.33301 17.7913 9.33301C20.3749 9.33301 22.2334 9.41351 23.508 9.50451C24.9179 9.60484 25.9778 10.6653 26.0782 12.0747C26.1692 13.3493 26.2497 15.2078 26.2497 17.7913C26.2497 20.3749 26.1692 22.2334 26.0782 23.508C25.9778 24.9179 24.9173 25.9778 23.508 26.0782C22.2334 26.1692 20.3749 26.2497 17.7913 26.2497C15.2078 26.2497 13.3493 26.1692 12.0747 26.0782Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'margins':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M6.16704 4H9.66704V25H6.16704C6.01381 25.0001 5.86206 24.97 5.72048 24.9114C5.57889 24.8528 5.45023 24.7669 5.34185 24.6585C5.23347 24.5502 5.1475 24.4216 5.08885 24.28C5.03019 24.1385 5 23.9868 5 23.8335V5.16648C5 5.01325 5.03019 4.86152 5.08885 4.71996C5.1475 4.5784 5.23347 4.44978 5.34185 4.34146C5.45023 4.23313 5.57889 4.14722 5.72048 4.08863C5.86206 4.03004 6.01381 3.99993 6.16704 4Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.833 4H18.333V25H21.833C21.9862 25.0001 22.1379 24.97 22.2795 24.9114C22.4211 24.8528 22.5498 24.7669 22.6581 24.6585C22.7665 24.5502 22.8525 24.4216 22.9112 24.28C22.9698 24.1385 23 23.9868 23 23.8335V5.16648C23 5.01325 22.9698 4.86152 22.9112 4.71996C22.8525 4.5784 22.7665 4.44978 22.6581 4.34146C22.5498 4.23313 22.4211 4.14722 22.2795 4.08863C22.1379 4.03004 21.9862 3.99993 21.833 4Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23 5.00024L23 8L5 8L5 5.00024C4.99994 4.86891 5.02575 4.73885 5.07597 4.6175C5.12619 4.49615 5.19983 4.38588 5.29268 4.29299C5.38553 4.20011 5.49577 4.12642 5.61711 4.07615C5.73844 4.02588 5.8685 4 5.99984 4L22.0002 4C22.1315 4 22.2616 4.02588 22.3829 4.07615C22.5042 4.12642 22.6145 4.20011 22.7073 4.29299C22.8002 4.38588 22.8738 4.49615 22.924 4.6175C22.9742 4.73885 23.0001 4.86891 23 5.00024Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23 23.9998L23 21L5 21L5 23.9998C4.99994 24.1311 5.02575 24.2611 5.07597 24.3825C5.12619 24.5039 5.19983 24.6141 5.29268 24.707C5.38553 24.7999 5.49577 24.8736 5.61711 24.9239C5.73844 24.9741 5.8685 25 5.99984 25L22.0002 25C22.1315 25 22.2616 24.9741 22.3829 24.9239C22.5042 24.8736 22.6145 24.7999 22.7073 24.707C22.8002 24.6141 22.8738 24.5039 22.924 24.3825C22.9742 24.2611 23.0001 24.1311 23 23.9998Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'orientation':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M16.333 3.5V8.16667C16.333 8.47609 16.4559 8.77283 16.6747 8.99162C16.8935 9.21042 17.1903 9.33333 17.4997 9.33333H22.1663"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.6663 24.5H8.16634C7.5475 24.5 6.95401 24.2542 6.51643 23.8166C6.07884 23.379 5.83301 22.7855 5.83301 22.1667V5.83333C5.83301 5.21449 6.07884 4.621 6.51643 4.18342C6.95401 3.74583 7.5475 3.5 8.16634 3.5H16.333L22.1663 9.33333V11.6667M15.1663 23.3333H20.9997C21.6185 23.3333 22.212 23.0875 22.6496 22.6499C23.0872 22.2123 23.333 21.6188 23.333 21V15.1667"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4993 25.6667L15.166 23.3334L17.4993 21.0001M20.9993 17.5001L23.3327 15.1667L25.666 17.5001"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'size':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M2.74707 26.05H5.08059M3.91355 5.90628L3.91383 26.05M2.74707 5.90625H5.08059"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.73685 1.35474L6.73685 3.16405M23.3554 2.25918L6.73685 2.25939M23.3555 1.35474L23.3555 3.16405"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.456 7.41287V24.9129C23.456 25.2222 23.3331 25.5189 23.1144 25.7377C22.8956 25.9564 22.5989 26.0793 22.2895 26.0793H8.28953C7.98016 26.0793 7.68346 25.9564 7.4647 25.7377C7.24594 25.5189 7.12305 25.2222 7.12305 24.9129V6.24583C7.12305 5.93646 7.24594 5.63976 7.4647 5.421C7.68346 5.20224 7.98016 5.07935 8.28953 5.07935H21.123M23.456 7.41287L21.123 5.07935M23.456 7.41287H21.123V5.07935"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'columns':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M2 5.5H9.45161M2 11.1667H9.45161M2 16.8333H9.45161M2 22.5H9.45161M18.5484 5.5H26M18.5484 11.1667H26M18.5484 16.8333H26M18.5484 22.5H26"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 3L14 25"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'watermark':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M26 13.1044C23.1578 15.3341 19.151 16.9205 14 11.8587C8.84896 6.79687 4.84313 8.38322 2 10.6129M26 19.3872C23.1578 21.6169 19.151 23.2033 14 18.1404C8.84896 13.0776 4.84313 14.665 2 16.8947"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 26L6.212 16.61M10.424 7.22C11.984 3.74 12.76 2 14 2C15.24 2 16.016 3.74 17.576 7.22L19.682 11.915L20.5165 13.7754M26 26L24.369 22.364M21.788 16.61L23.1042 19.5444M9 10.5L7.606 13.555"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'clearFormatting':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M16.7934 9.06385L11.9694 2.6626L5.30078 7.6876L10.3127 13.8751L11.5712 12.9991L16.7934 9.06385Z"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.3125 13.8751L8.87291 15.0282L4.91179 15.0278L3.93679 13.7341L1.52441 10.5331L5.43754 7.58447"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.95215 15.0271H16.7121"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'subScript':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.6667 18.677H16L18.3333 16.0104C18.4209 15.8572 18.4774 15.6882 18.4996 15.5132C18.5219 15.3381 18.5095 15.1604 18.463 14.9902C18.4166 14.8199 18.3371 14.6605 18.2291 14.521C18.121 14.3815 17.9865 14.2646 17.8333 14.177C17.6801 14.0895 17.5112 14.033 17.3361 14.0107C17.1611 13.9885 16.9834 14.0009 16.8131 14.0473C16.6429 14.0938 16.4834 14.1733 16.3439 14.2813C16.2044 14.3894 16.0875 14.5238 16 14.677"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 3.75L12.5 15M3.75 15L12.5 3.75"
            stroke="#101223"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'superScript':
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1827 5.31251C10.4702 4.95313 10.9952 4.89512 11.3546 5.18263C11.7137 5.47011 11.7717 5.99421 11.4845 6.35353L8.56651 10L11.4845 13.6465C11.7717 14.0058 11.7138 14.5299 11.3546 14.8174C10.9952 15.1049 10.4702 15.0469 10.1827 14.6875L7.5001 11.333L4.81748 14.6875C4.52993 15.0466 4.00585 15.1048 3.64659 14.8174C3.28724 14.5299 3.22929 14.0059 3.5167 13.6465L6.43272 10L3.5167 6.35353C3.22924 5.99414 3.28722 5.47012 3.64659 5.18263C4.00587 4.89521 4.52993 4.95339 4.81748 5.31251L7.5001 8.66603L10.1827 5.31251ZM14.964 2.57521C15.607 2.39985 16.2935 2.4877 16.8722 2.81837C17.1586 2.98206 17.4104 3.20013 17.6124 3.46095C17.8145 3.72187 17.9631 4.0205 18.0499 4.33888C18.1367 4.65708 18.1598 4.98923 18.1183 5.31642C18.0766 5.64379 17.9714 5.96055 17.8077 6.24708C17.7802 6.29519 17.7475 6.34014 17.711 6.38185L16.004 8.33302H17.5001C17.9603 8.33302 18.3341 8.70677 18.3341 9.16701C18.3339 9.62707 17.9602 10 17.5001 10H14.1671C13.8401 10 13.5434 9.80851 13.4083 9.51076C13.2733 9.21306 13.3249 8.86421 13.5401 8.61818L16.3907 5.35841C16.428 5.27878 16.4538 5.19397 16.4649 5.10646C16.4789 4.99628 16.4707 4.8845 16.4415 4.77736C16.4123 4.67016 16.3631 4.56931 16.295 4.48146C16.227 4.39359 16.1415 4.32078 16.045 4.26564C15.8501 4.15428 15.619 4.12455 15.4024 4.18361C15.186 4.24271 15.002 4.38532 14.8907 4.58009C14.6625 4.97953 14.1535 5.1186 13.754 4.89064C13.3544 4.6623 13.2151 4.15254 13.4435 3.75294C13.7741 3.17439 14.3211 2.75058 14.964 2.57521Z"
            fill="#101223"
          />
        </svg>
      );
      break;
    case 'header':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M22.9013 3L5.09924 3C4.49265 3 4 3.54736 4 4.22203V23.778C4 24.4526 4.49213 25 5.09924 25H22.9013C23.5079 25 24 24.4526 24 23.778V4.22203C24 3.54736 23.5079 3 22.9013 3Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 6H7V10H21V6Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'footer':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M22.9013 3L5.09924 3C4.49265 3 4 3.54736 4 4.22203V23.778C4 24.4526 4.49213 25 5.09924 25H22.9013C23.5079 25 24 24.4526 24 23.778V4.22203C24 3.54736 23.5079 3 22.9013 3Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 18H7V22H21V18Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'pageNumber':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M18.1852 15.3999L15.5585 25.1999M14.9799 18.3398H23.8M14 22.26H22.8201M22.242 15.3999L19.6157 25.1999"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.4995 22.1665H5.83306C5.67982 22.1666 5.52808 22.1364 5.38649 22.0778C5.2449 22.0193 5.11624 21.9334 5.00787 21.825C4.89949 21.7167 4.81352 21.5881 4.75486 21.4465C4.69621 21.305 4.66602 21.1532 4.66602 21V10.5L11.666 3.5H18.666C18.8193 3.49993 18.971 3.53004 19.1126 3.58863C19.2542 3.64722 19.3828 3.73313 19.4912 3.84146C19.5996 3.94978 19.6856 4.0784 19.7442 4.21996C19.8029 4.36152 19.8331 4.51325 19.8331 4.66648V10.5"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.666 10.5V3.5L4.66602 10.5H11.666Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'print':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14.2416 13.3332H16.6668C16.8878 13.3332 17.0997 13.2454 17.256 13.0892C17.4122 12.9329 17.5 12.721 17.5 12.5V5.8332C17.5 5.61222 17.4122 5.40029 17.256 5.24404C17.0997 5.08778 16.8878 5 16.6668 5H3.3332C3.11222 5 2.90029 5.08778 2.74404 5.24404C2.58778 5.40029 2.5 5.61222 2.5 5.8332V12.5C2.5 12.721 2.58778 12.9329 2.74404 13.0892C2.90029 13.2454 3.11222 13.3332 3.3332 13.3332H5.7584M14.1668 2.5H5.8332V5H14.1668V2.5Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 17.5001H5L6.6668 8.33325H13.3332L15 17.5001Z"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'left':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="23"
          viewBox="0 0 22 23"
          fill="none"
        >
          <rect
            width="18"
            height="18"
            transform="translate(1.625 1.875)"
            fill="none"
          />
          <rect width="22" height="23" rx="2" fill="none" />
          <path
            d="M5 10.875H11M5 15.5625H16.25M5 6.1875H16.25"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'center':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.375 13.6875H14.625M3.375 4.3125H14.625"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 9H12"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'right':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M14.625 9H8.625M14.625 4.3125H3.375M14.625 13.6875H3.375"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'justify':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M14.625 9H3.375M14.625 4.3125H3.375M14.625 13.6875H3.375"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'bulletList':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.33223 4.809C3.88355 4.809 4.33048 4.36207 4.33048 3.81075C4.33048 3.25943 3.88355 2.8125 3.33223 2.8125C2.78092 2.8125 2.33398 3.25943 2.33398 3.81075C2.33398 4.36207 2.78092 4.809 3.33223 4.809Z"
            fill="#101223"
          />
          <path
            d="M6.8418 3.81006H15.6655"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33223 9.99821C3.88355 9.99821 4.33048 9.55128 4.33048 8.99996C4.33048 8.44864 3.88355 8.00171 3.33223 8.00171C2.78092 8.00171 2.33398 8.44864 2.33398 8.99996C2.33398 9.55128 2.78092 9.99821 3.33223 9.99821Z"
            fill="#101223"
          />
          <path
            d="M6.8418 9H15.6655"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33223 15.1874C3.88355 15.1874 4.33048 14.7405 4.33048 14.1892C4.33048 13.6379 3.88355 13.1909 3.33223 13.1909C2.78092 13.1909 2.33398 13.6379 2.33398 14.1892C2.33398 14.7405 2.78092 15.1874 3.33223 15.1874Z"
            fill="#101223"
          />
          <path
            d="M6.8418 14.1899H15.6655"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'numberedList':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M7.6875 3.75H15.1875M7.6875 9H15.1875M7.6875 14.25H15.1875M2.8125 2.8125L4.3125 2.0625V5.4375M2.8125 8.15625C2.88458 7.88896 3.05146 7.65703 3.282 7.50375C3.51301 7.35008 3.79188 7.28531 4.06697 7.32144C4.34206 7.35757 4.59475 7.49214 4.77825 7.70025C5.202 8.18025 4.7925 8.88525 4.31925 9.3165L2.8125 10.6875H5.0625M2.8125 12.5625H5.052L3.7545 14.0753C3.98469 14.0432 4.21926 14.0722 4.43475 14.1592C4.6455 14.2455 4.81875 14.385 4.92975 14.5582C5.04075 14.7307 5.0835 14.928 5.05275 15.1223C5.02275 15.3173 4.91925 15.4972 4.75875 15.6412C4.58826 15.7884 4.37982 15.8845 4.15725 15.9188C3.90238 15.9566 3.64218 15.9343 3.3975 15.8535C3.18375 15.7733 2.931 15.6382 2.8125 15.4688"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'lineHeight':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M8.25 4.5H15.75M8.25 9H15.75M8.25 13.5H15.75M3.75 14.25V3.75M3.75 14.25L2.25 12.375M3.75 14.25L5.25 12.375M3.75 3.75L2.25 5.25M3.75 3.75L5.25 5.25"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'decreaseIndent':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M14.625 9.1875H12.625M14.625 13.875H3.375M14.625 4.5H3.375"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.625 9.1875H3.625M3.625 9.1875L4.8125 8M3.625 9.1875L4.8125 10.375"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'increaseIndent':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M12.375 9.1875H14.375M3.375 13.875H14.625M3.375 4.5H14.625"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 9.1875H10M10 9.1875L8.8125 8M10 9.1875L8.8125 10.375"
            stroke="#101223"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'undo':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g opacity={disabled ? 0.3 : 1}>
            <path
              d="M2.5 7.50001H13.75C14.2428 7.49895 14.7309 7.59523 15.1863 7.78331C15.6418 7.97139 16.0556 8.24758 16.404 8.59601C16.7524 8.94444 17.0286 9.35825 17.2167 9.8137C17.4048 10.2691 17.5011 10.7573 17.5 11.25C17.501 11.7427 17.4047 12.2308 17.2166 12.6863C17.0285 13.1417 16.7523 13.5555 16.4039 13.9039C16.0555 14.2523 15.6417 14.5285 15.1863 14.7166C14.7308 14.9047 14.2427 15.001 13.75 15H10.8332"
              stroke="#101223"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 10L2.5 7.5L5 5"
              stroke="#101223"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
      break;
    case 'redo':
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g opacity={disabled ? 0.3 : 1}>
            <path
              d="M9.16681 15H6.25001C5.75723 15.0012 5.26907 14.905 4.81358 14.7169C4.35808 14.5289 3.94422 14.2527 3.59577 13.9042C3.24732 13.5558 2.97114 13.1419 2.7831 12.6864C2.59505 12.2309 2.49885 11.7428 2.50001 11.25C2.4989 10.7572 2.59514 10.2691 2.78321 9.81364C2.97127 9.35817 3.24745 8.94433 3.59589 8.59589C3.94433 8.24745 4.35817 7.97127 4.81364 7.78321C5.26911 7.59514 5.75724 7.4989 6.25001 7.50001H17.5"
              stroke="#101223"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 5L17.5 7.5L15 10"
              stroke="#101223"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
      break;
    case 'trash':
      icon = (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="#101223">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
        </svg>
      );
      break;
  }

  return icon;
};

export default ToolbarIcons;
